export function shop() {
  const shops = document.querySelectorAll('.js-shop');
  const btn_open = 'img_btn_open';
  const btn_close = 'img_btn_close'

  shops.forEach(shop => {
    const shopList = shop.querySelector('.js-shopList');
    const shopList_item = shopList.querySelectorAll('li');
    const shopBtn = shop.querySelector('.js-shopBtn');
    const shopBtn_img = shopBtn.querySelector('img');

    if(shopList_item.length % 2 === 1) {
      const item_element = document.createElement('li');
      item_element.classList.add('c-listShop_item');
      shopList.appendChild(item_element);
    }

    shopBtn.addEventListener('click', () => {
      shopList.classList.toggle('is-active');

      if(shopBtn.classList.contains('is-active')) {
        shopBtn_img.setAttribute('src', `./img/index/${btn_open}.svg`);
        shopBtn_img.setAttribute('alt', 'OPEN');
        shopBtn.classList.remove('is-active');
      } else {
        shopBtn_img.setAttribute('src', `./img/index/${btn_close}.svg`);
        shopBtn_img.setAttribute('alt', 'CLOSE');
        shopBtn.classList.add('is-active');
      }
    })
  });
}